import { withRouter } from 'react-router-dom'
import roleProcessor from '../processor/roleProcessor'
import Crud from '../components/form/Crud'
import RoleTree from '../components/form/RoleTree'

function Role() {
  const moduleName = 'quyền'
  const processor = roleProcessor
  const column = [{ value: 'name', name: 'Tên', sortable: true }]
  const savePermission = async (id, keys) => {
    await roleProcessor.updateRolePermission(id, keys)
  }

  const config = {
    fields: ['name'],
    maxLength: { userName: 20 },
    minLength: { userName: 4 },
    name: {
      name: 'Tên',
    },
    disable: (oneData) => (!oneData.id ? [] : ['name']),
  }

  return (
    <>
      <Crud
        processor={processor}
        moduleName={moduleName}
        column={column}
        config={config}
        chucNang={(data) => <RoleTree id={data.id} onSave={savePermission} />}
        canEdit={false}
      />
    </>
  )
}

export default withRouter(Role)
